<template>
  <div class="">

    <div class="feature-area work_fields-area pt-100 pb-70 custom-shape-divider">
      <div class="container p-0">
        <div class="section-title">
          <h2 v-if="!dataLoading">{{ $t('app.workFields') }}</h2>
          <h2 v-if="dataLoading" class="webkit-animation col-4 offset-4 webkit-none-50"></h2>
        </div>

        <div v-if="dataLoading" class="col-12 row">
          <div class="item col-3" v-for="(item, idx) in 4" :key="idx">
            <div class="feature-item two webkit-animation webkit-none-220">
            </div>
          </div>
        </div>
        <!--  :items="5"  -->
        <carousel v-if="!dataLoading && work_fields && work_fields.length" :autoplay="true" :loop="true" :dots="false"
          :margin="20" :touchDrag="true" :items="5" :center="true"
          :responsive="{ 0: { items: 2 }, 767: { items: 2 }, 1000: { items: 5 } }" :nav="true"
          :navText="[`<i class='icofont-rounded-double-left'></i>`, `<i class='icofont-rounded-double-right'></i>`]">

          <div class="item" v-for="(item, idx) in work_fields" :key="idx">
            <div class="feature-item two">
              <img v-if="item.image" :src="item.image" style="width:140px;height: 140px;border-radius: 50%">
              <h3>
                <a href="javascript:;">
                  {{ ($i18n.locale == 'en') ? item.en.title : item.ar.title }}
                </a>
              </h3>
              <span class="text-center">
                {{ ($i18n.locale == 'en') ? item.en.body : item.ar.body }}
              </span>
            </div>
          </div>
        </carousel>

      </div>
    </div>

  </div>
</template>

<script>
import carousel from 'v-owl-carousel'

export default {
  name: 'WorkFields',
  components: {
    carousel
  },
  data() {
    return {
      //
      work_fields: [],
      pgLoading: true,
      dataLoading: true,
      refs: 'workFields'
    }
  },
  mounted() {
  },
  created() {
    this.fetchService();
  },
  methods: {
    fetchService() {
      this.dataLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/' + this.refs,
        method: 'GET',
        data: {},
        headers: {
          appId: process.env.VUE_APP_APPID
        },
      }
      this.axios(options)
        .then(res => {
          this.dataLoading = false;
          this.work_fields = res.data.data.rows;
        })
        .catch(() => {
          //
        })
        .finally(() => {
        });
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
